import createIcon from '../../createIcon';

/**
 * @component @name Undo
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMjY0NiA4LjVDOS42MTQ2NSA4LjUgNy4yMTQ2NSA5LjQ5IDUuMzY0NjUgMTEuMUwxLjc2NDY1IDcuNVYxNi41SDEwLjc2NDZMNy4xNDQ2NSAxMi44OEM4LjUzNDY1IDExLjcyIDEwLjMwNDYgMTEgMTIuMjY0NiAxMUMxNS44MDQ2IDExIDE4LjgxNDYgMTMuMzEgMTkuODY0NiAxNi41TDIyLjIzNDYgMTUuNzJDMjAuODQ0NiAxMS41MyAxNi45MTQ2IDguNSAxMi4yNjQ2IDguNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Undo = createIcon('Undo', [
  [
    'path',
    {
      d: 'M12.2646 8.5C9.61465 8.5 7.21465 9.49 5.36465 11.1L1.76465 7.5V16.5H10.7646L7.14465 12.88C8.53465 11.72 10.3046 11 12.2646 11C15.8046 11 18.8146 13.31 19.8646 16.5L22.2346 15.72C20.8446 11.53 16.9146 8.5 12.2646 8.5Z',
      key: 'iex8g2',
    },
  ],
]);

export default Undo;
